import { createApp } from 'vue'
import App from './App.vue'
import router from "./router/index"
import ElementPlus from 'element-plus';
import 'element-plus/theme-chalk/index.css';
import vueI18n from "@/lang/index";
import vuex from "@/lang/store"




const app = createApp(App);
app.use(router);
app.use(ElementPlus)
app.use(vueI18n)
app.use(vuex)

app.mount('#app');